<template>
  <div class="sc">
    <i class="iconfont">&#xe64b;</i>
    <p class="p1">提交成功，审核中</p>
    <p class="p2">在此期间如有任何疑问<br>可以扫描二维码添加在线客服咨询</p>
    <img class="smt-ewm" :src="$store.state.static_img_url + 'pic/apply/ewm3.png'" />
    <a>{{wait}}s后返回上一页</a>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      waitInterval: '',
      wait: 10,
    }
  },
  computed: {},
  methods: {},
  created() {},
  mounted() {
    this.waitInterval = setInterval(() => {
      this.wait--
      if (this.wait == 0) {
        this.$router.push({ name: 'MApplyTest' })
        clearInterval(this.waitInterval)
      }
    }, 1000)
  },
  beforeDestroy() {
    clearInterval(this.waitInterval)
    this.waitInterval = ''
  },
}
</script>
<style lang="stylus" scoped>
.sc
  text-align center
  padding-top 1.6rem
  display flex
  flex-direction column
  align-items center
  i
    font-size 1rem
    color #67c23a
  .p1
    font-size 0.36rem
    font-weight 800
    color #212121
    margin-top 0.4rem
  .p2
    font-size 0.22rem
    font-weight 500
    color #999999
    line-height 0.36rem
    margin-top 0.4rem
    span
      color #ff8824
  .smt-ewm
    margin-top 0.4rem
    width 2.4rem
  a
    color #ff8824
    line-height 0.36rem
    margin-top 0.6rem
</style>